import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../helpers/reselectHelpers';
import {getBadgeValue} from '../../store/data/preferences/countersSelectors';
import {Title} from './title';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  badgeValue: getBadgeValue,
}));

export const TitleContainer = connect(mapStateToProps)(Title);
